import type { VietnameseCitation } from "./types";

const knownCitations: Readonly<
  Record<string, { titleVi: string; versionVi?: string }>
> = Object.freeze({
  "method:bazi-solar-v1": {
    titleVi: "Phương pháp lập tứ trụ Bát Tự từ lịch dương",
    versionVi: "Phiên bản kỹ thuật 1",
  },
  "package:lunar-javascript@1.7.6": {
    titleVi: "Thư viện chuyển đổi lịch",
    versionVi: "Phiên bản 1.7.6",
  },
  "method:ziwei-solar-v1": {
    titleVi: "Phương pháp lập lá số Tử Vi từ lịch dương",
    versionVi: "Phiên bản kỹ thuật 1",
  },
  "package:iztro@2.4.3": {
    titleVi: "Thư viện lập lá số Tử Vi",
    versionVi: "Phiên bản 2.4.3",
  },
  "method:mai-hoa-time-cast-v1": {
    titleVi: "Phương pháp lập quẻ Mai Hoa theo giờ",
    versionVi: "Phiên bản kỹ thuật 1",
  },
  "reference:king-wen-hexagram-names-vi@public-domain": {
    titleVi: "Bảng tên Hán Việt 64 quẻ và 8 quái theo thứ tự Văn Vương",
    versionVi: "Tư liệu cổ điển công cộng",
  },
  "method:pythagoras-core-v1": {
    titleVi: "Phương pháp Thần số học Pythagoras cốt lõi",
    versionVi: "Phiên bản kỹ thuật 1",
  },
  "convention:pythagoras-y-consonant-v1": {
    titleVi: "Quy ước xem chữ Y là phụ âm trong Thần số học",
    versionVi: "Phiên bản quy ước 1",
  },
  "reference:khi-van-tong-hop-ruleset-v1@owner-signed": {
    titleVi:
      "Bản chốt quy ước Phong Thủy và Tên/số Ngũ Hành do chủ sản phẩm tự chọn — không phải chuyên gia độc lập ký duyệt",
    versionVi: "Bản chốt quy ước, phiên bản 1",
  },
});

function fallbackCitation(sourceRef: string): {
  titleVi: string;
  versionVi?: string;
} {
  if (sourceRef.startsWith("code:dich-so-ai@")) {
    return {
      titleVi: "Mã nguồn tra cứu bảng quẻ Kinh Dịch",
      versionVi: "Mã tham chiếu nội bộ",
    };
  }
  if (sourceRef.startsWith("package:")) {
    return { titleVi: "Thư viện kỹ thuật nội bộ" };
  }
  if (sourceRef.startsWith("method:")) {
    return { titleVi: "Phương pháp tính toán nội bộ" };
  }
  if (sourceRef.startsWith("convention:")) {
    return { titleVi: "Quy ước tính toán nội bộ" };
  }
  if (sourceRef.startsWith("code:")) {
    return { titleVi: "Mã nguồn tham chiếu nội bộ" };
  }
  if (sourceRef.startsWith("reference:")) {
    return { titleVi: "Tư liệu tham chiếu nội bộ" };
  }
  return { titleVi: "Nguồn kỹ thuật nội bộ" };
}

export function translateCitation(sourceRef: string): VietnameseCitation {
  const known = knownCitations[sourceRef] ?? fallbackCitation(sourceRef);
  return Object.freeze({
    id: sourceRef,
    titleVi: known.titleVi,
    versionVi: known.versionVi,
  });
}

export function translateCitations(
  sourceRefs: readonly string[],
): readonly VietnameseCitation[] {
  const unique = Array.from(new Set(sourceRefs));
  return Object.freeze(unique.map(translateCitation));
}
